import { ComponentChildren, ComponentType, createContext } from 'preact'
import { useContext } from 'preact/hooks'
import EventTracker from './EventTracker'

const TrackerContext = createContext<EventTracker>({} as EventTracker)

export const TrackerProvider = ({ children, ga }: { children: ComponentChildren; ga: () => void }) => {
  return <TrackerContext.Provider value={new EventTracker(ga)}>{children}</TrackerContext.Provider>
}

interface WithTrackerProps {
  tracker: EventTracker
}

export function withTracker<T extends WithTrackerProps = WithTrackerProps>(WrappedComponent: ComponentType<T>) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  function ComponentWithTracker(props: Omit<T, keyof WithTrackerProps>) {
    const tracker = useTracker()
    return <WrappedComponent {...(props as T)} tracker={tracker} />
  }

  ComponentWithTracker.displayName = `withTracker(${displayName})`

  return ComponentWithTracker
}

export const useTracker = () => useContext(TrackerContext)
